export default __webpack_public_path__ + "static/media/icon-android.a9f3b732.svg";